/** dv-charts / ECharts 坐标轴刻度标签字号（横轴、纵轴） */
export const CHART_AXIS_TICK_FONT_SIZE = 13

/** 柱状图柱顶/柱上数值 label 字号 */
export const CHART_BAR_VALUE_LABEL_FONT_SIZE = 14

function mergeAxisLabel (axisLabel, fontSize) {
  if (axisLabel && axisLabel.show === false) {
    return axisLabel
  }
  const prev = axisLabel || {}
  return {
    ...prev,
    style: {
      ...(prev.style || {}),
      fontSize
    }
  }
}

function patchAxis (axis, fontSize) {
  if (!axis || typeof axis !== 'object') return axis
  return {
    ...axis,
    axisLabel: mergeAxisLabel(axis.axisLabel, fontSize)
  }
}

function patchAxisList (axisConfig, fontSize) {
  if (!axisConfig) return axisConfig
  if (Array.isArray(axisConfig)) {
    return axisConfig.map(axis => patchAxis(axis, fontSize))
  }
  return patchAxis(axisConfig, fontSize)
}

/**
 * 为 option 的 xAxis / yAxis 刻度标签统一放大字号（不破坏 formatter 等函数引用）
 */
export function withChartAxisTickFontSize (option, fontSize = CHART_AXIS_TICK_FONT_SIZE) {
  if (!option || typeof option !== 'object') return option
  const next = { ...option }
  if (next.xAxis !== undefined) {
    next.xAxis = patchAxisList(next.xAxis, fontSize)
  }
  if (next.yAxis !== undefined) {
    next.yAxis = patchAxisList(next.yAxis, fontSize)
  }
  return next
}

function patchBarSeriesLabel (series, fontSize) {
  if (!series || typeof series !== 'object' || series.type !== 'bar') {
    return series
  }
  if (!series.label || series.label.show === false) {
    return series
  }
  return {
    ...series,
    label: {
      ...series.label,
      style: {
        ...(series.label.style || {}),
        fontSize
      }
    }
  }
}

function patchSeriesList (seriesConfig, fontSize) {
  if (!seriesConfig) return seriesConfig
  if (Array.isArray(seriesConfig)) {
    return seriesConfig.map(s => patchBarSeriesLabel(s, fontSize))
  }
  return patchBarSeriesLabel(seriesConfig, fontSize)
}

/** 柱状图 series 上显示的数值 label 字号 */
export function withChartBarValueLabelFontSize (option, fontSize = CHART_BAR_VALUE_LABEL_FONT_SIZE) {
  if (!option || typeof option !== 'object') return option
  const next = { ...option }
  if (next.series !== undefined) {
    next.series = patchSeriesList(next.series, fontSize)
  }
  return next
}

/** 坐标轴刻度 + 柱状数值 label 一并规范化 */
export function normalizeChartOption (option) {
  return withChartBarValueLabelFontSize(withChartAxisTickFontSize(option))
}

/** 柱状图柱顶数值 label */
export function barSeriesValueLabel (extraStyle = {}) {
  return {
    show: true,
    style: {
      fill: '#fff',
      fontSize: CHART_BAR_VALUE_LABEL_FONT_SIZE,
      ...extraStyle
    }
  }
}

/** 柱状图等：横轴类目刻度 */
export function categoryAxisLabel (extraStyle = {}) {
  return {
    style: {
      fill: '#fff',
      fontSize: CHART_AXIS_TICK_FONT_SIZE,
      ...extraStyle
    }
  }
}

/** 柱状图等：纵轴数值刻度 */
export function valueAxisLabel (extraStyle = {}) {
  return {
    style: {
      fill: '#fff',
      fontSize: CHART_AXIS_TICK_FONT_SIZE,
      ...extraStyle
    },
    formatter: function ({ value }) {
      return parseInt(value)
    }
  }
}
